import 'babel-polyfill';
import Vuex from 'vuex';
import Vue from 'vue';
import common from './common/common';
import config from '../others/interface';
import article from './articleDetails/articleDetails';

Vue.use(Vuex);

// let [userinfo, token, ] = [{}, '', ];

export function createStore () {
  return new Vuex.Store({
    modules: {article, },
    state: {
      config,
      ...common.state,
    },
    actions: {
      ...common.actions,
    },
    mutations: {
      ...common.mutations,

    },
  });
}



// WEBPACK FOOTER //
// src/store/index.js